import { useRef } from 'react';
import { useSiteMotion } from '../anim/useSiteMotion.ts';
import { ContactForm, INBOX } from '../components/ContactForm.tsx';

export function ContactPage() {
  const page = useRef<HTMLElement>(null);
  useSiteMotion(page);

  return (
    <main className="sec contact" id="top" ref={page}>
      <h1 className="cta__title contact__title">
        Tell us what
        <br />
        <span className="grad">is on your floor.</span>
      </h1>

      <p className="sec__sub contact__sub">
        Whether you run the floor, build the robots on it, or write the system that gives them
        work, it is the same conversation and the same inbox.
      </p>

      <ContactForm />

      <div className="contact__direct">
        <p>
          Would rather not fill anything in? <a href={`mailto:${INBOX}`}>{INBOX}</a>
        </p>
        <p className="contact__where">
          We work across Central and Eastern Europe, and validate on a working floor in Romania.
        </p>
      </div>
    </main>
  );
}
